import React, { useEffect, useState, useRef } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { Button, Modal, Form, message } from "antd";
import {
  collection,
  addDoc,
  doc,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";

import dayjs from "dayjs";

import { db } from "../firebaseConfig";
import TicketLayout from "./TicketLayout";
import TicketForm from "./TicketForm";
import TicketModal from "./TicketModal";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const AddTicket = () => {
  const [editingTicket, setEditingTicket] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [newTicketModal, setNewTicketModal] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const ticketRef = useRef();

  const handleViewPDF = (ticket) => {
    setSelectedTicket(ticket); // Configura el ticket seleccionado
  };

  const handleSaveTicket = (updatedTicket) => {
    if (editingTicket) {
      // Actualizar el ticket existente
      console.log("Editando ticket:", updatedTicket);
    } else {
      // Crear un nuevo ticket
      console.log("Creando nuevo ticket:", updatedTicket);
    }
    setEditingTicket(null); // Limpiar estado
  };

  const handleCloseTicketModal = () => {
    setSelectedTicket(null);
    setNewTicketModal(false);
  };

  const handleDownloadPDF = async () => {
    const element = ticketRef.current;
    const canvas = await html2canvas(element, {
      scale: 2, // Mejora la calidad para pequeñas impresoras
    });
    const data = canvas.toDataURL("image/png");

    const mmToPoints = 2.83465; // Conversión de mm a puntos
    const pdfWidth = 60 * mmToPoints; // 60 mm ancho
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;
    const pdfHeight = (imgHeight * pdfWidth) / imgWidth; // Ajustar la altura proporcionalmente

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: [pdfWidth, pdfHeight], // Tamaño ajustado
    });

    pdf.addImage(data, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`ticket_${selectedTicket.id}.pdf`);
  };

  const generatePdfBase64 = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const element = ticketRef.current;

      if (!element) {
        console.error("Elemento no encontrado");
        return;
      }

      // Espera para asegurarse de que todo esté renderizado

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true, // Permite cargar imágenes externas
      });

      const data = canvas.toDataURL("image/jpeg");

      const mmToPoints = 2.83465;
      const pdfWidth = 60 * mmToPoints;
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const pdfHeight = (imgHeight * pdfWidth) / imgWidth;

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: [pdfWidth, pdfHeight],
      });

      pdf.addImage(data, "JPEG", 0, 0, pdfWidth, pdfHeight);

      const pdfBase64 = pdf.output("datauristring").split(",")[1];
      return pdfBase64;
    } catch (error) {
      console.log("Error al generar el PDF:", error);
    }
  };

  const handlePrint = async () => {
    const element = ticketRef.current;
    const printWindow = window.open("", "_blank");
    if (printWindow) {
      printWindow.document.write(
        "<html><head><title>Print</title></head><body>",
      );
      printWindow.document.write(element.outerHTML); // Copia el contenido del ticket
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.focus();
      printWindow.print(); // Imprime directamente
      printWindow.close(); // Cierra la ventana de impresión
    }
  };

  // Open and close modal

  const handleCancel = () => {
    setSelectedTicket(null);
  };

  const generateUniqueId = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"; // Letras y números
    let id = "";
    for (let i = 0; i < 7; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
  };

  const handleCreateTicket = async (values) => {
    try {
      const fechaEmision = new Date().toISOString(); // Fecha y hora actual

      const ticketId = generateUniqueId(); // Generar un ID único

      const newTicket = {
        id: ticketId,
        fechaEmision,
        precio: values.precio,
        email: values.email,
        informacionPersonal: values.informacionPersonal,
        enviarEmail: values.enviarEmail,
        nombreTecnico: "Técnico",
        guia: values.guia || "",
        grupoSize: values.grupoSize,
        tipoEntrada: values.tipoEntrada,
        provincia: values.provincia,
        visita: values.visita,
        paisOrigen: values.paisOrigen,
        fechaYHora: values.fechaYHora?.toISOString() || null,
        empresaLocal: values.empresaLocal === true,
        consumido: false,
      };

      console.log("Valores del formulario:", newTicket);
      //console.log("Valores del formulario:", newTicket);

      // Guardar en Firestore
      await addDoc(collection(db, "tickets"), newTicket);
      message.success(
        `Ticket creado correctamente con ID: ${ticketId} y precio: ${newTicket.precio}€`,
      );

      setSelectedTicket(newTicket);
      setNewTicketModal(true);

      if (values.enviarEmail) {
        const dataBase64 = await generatePdfBase64();

        sendTicketEmail(values.email, {
          id: values.id,
          nombre: values.informacionPersonal,
          visita: values.visita,
          fecha: values.fechaYHora.format("DD/MM/YYYY HH:mm"),
          precio: values.precio,
          base64: dataBase64,
        });
      }
    } catch (error) {
      console.error("Error al guardar el ticket:", error);
      message.error("Hubo un problema al guardar el ticket");
    }
  };

  const sendTicketEmail = async (email, ticketData) => {
    try {
      const functions = getFunctions();
      const sendTicketEmail = httpsCallable(functions, "sendTicketEmail");

      const response = await sendTicketEmail({ email, ticketData });
      console.log(response.data.message); // Muestra el mensaje de éxito
      alert("Correo enviado con éxito.");
    } catch (error) {
      console.error("Error al enviar el correo:", error);
      alert("Hubo un error al enviar el correo.");
    }
  };

  const handleResendEmail = () => {
    generatePdfBase64().then((dataBase64) => {
      console.log("Base64 generado:", dataBase64);

      sendTicketEmail(selectedTicket.email, {
        id: selectedTicket.id,
        nombre: selectedTicket.informacionPersonal,
        visita: selectedTicket.visita,
        fecha: selectedTicket.fechaYHora,
        precio: selectedTicket.precio,
        base64: dataBase64,
      });
    });
  };

  const handleDeleteTicket = async () => {
    if (selectedTicket) {
      try {
        debugger;
        const ticketRef = doc(db, "tickets", selectedTicket.id);
        await deleteDoc(ticketRef);
        message.success("Ticket eliminado correctamente");
        setSelectedTicket(null);

        setIsDeleteModalVisible(false);
        setNewTicketModal(false);
      } catch (error) {
        console.error("Error al eliminar el ticket:", error);
        message.error("Hubo un problema al eliminar el ticket");
      }
    }
  };
  const handleEditTicket = (ticket) => {
    setEditingTicket(ticket);
    //setIsModalVisible(true);
    setNewTicketModal(false);
  };

  return (
    <div>
      <TicketForm
        visible={true}
        onSave={handleSaveTicket}
        ticketData={editingTicket}
        handleCreateTicket={handleCreateTicket}
        handleCancel={handleCancel}
      />

      <Modal
        title={`Ticket ${selectedTicket?.id}`}
        open={newTicketModal}
        onCancel={handleCloseTicketModal}
        footer={null}
        width={400}
      >
        {newTicketModal && (
          <TicketLayout ref={ticketRef} ticketData={selectedTicket} />
        )}

        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <Button type="primary" size="large" onClick={handleDownloadPDF}>
            Descargar PDF
          </Button>

          <Button type="primary" size="large" onClick={handleResendEmail}>
            Reenviar Email
          </Button>
          <Button
            type="dashed"
            size="large"
            style={{ marginLeft: "10px" }}
            onClick={() => handleEditTicket(selectedTicket)}
          >
            Editar
          </Button>
          <Button
            type="default"
            size="large"
            style={{ marginLeft: "10px" }}
            onClick={handlePrint}
          >
            Imprimir
          </Button>

          <Button
            type="danger"
            size="large"
            style={{ marginLeft: "10px" }}
            onClick={() => setIsDeleteModalVisible(true)}
          >
            Eliminar
          </Button>
          <Button
            size="large"
            style={{ marginLeft: "10px" }}
            onClick={handleCloseTicketModal}
          >
            Cerrar
          </Button>
        </div>
      </Modal>

      {/* Modal de Confirmación para eliminar el ticket */}
      <Modal
        title="Confirmar eliminación"
        open={isDeleteModalVisible}
        onOk={handleDeleteTicket}
        onCancel={() => setIsDeleteModalVisible(false)}
        okText="Eliminar"
        cancelText="Cancelar"
      >
        <p>
          ¿Estás seguro de que deseas eliminar este ticket? Esta acción no se
          puede deshacer.
        </p>
      </Modal>

      {/* Modal de edición del ticket */}
      <TicketModal
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        onSave={handleCreateTicket}
        ticketData={editingTicket}
        handleCreateTicket={handleCreateTicket}
        handleCancel={() => setEditingTicket(null)}
      />
    </div>
  );
};

export default AddTicket;
